import React, { useState } from 'react';
import classNames from 'classnames';

// Reuses the flag images django-countries already ships and the Django-rendered tables
// already draw (templates/ui/country_flag.html) — no new dependency.
export function countryFlagUrl(country: string | null | undefined): string | null {
  if (!country || country.length !== 2) return null;
  return `${window.appState.baseStaticUrl}flags/${country.toLowerCase()}.gif`;
}

type Props = {
  country: string | null | undefined;
  className?: string;
};

function CountryFlag({ country, className = 'h-3 w-4' }: Props) {
  const [failed, setFailed] = useState(false);
  const url = countryFlagUrl(country);

  if (!url || failed) {
    return <span className={classNames('inline-block shrink-0 rounded-sm bg-gray-100', className)} />;
  }

  return (
    <img
      src={url}
      alt=""
      title={country?.toUpperCase()}
      className={classNames('inline-block shrink-0 rounded-sm', className)}
      onError={() => setFailed(true)}
    />
  );
}

export default CountryFlag;
